// CANONICAL COPY (GH #7115). src/constants/obligations/obl-business-impact-analysis.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-business-impact-analysis',
  title: 'Perform business impact analysis',
  description:
    "Confirm that a business impact analysis (BIA) is performed and kept current (ISO 22301 Cl. 8.2). The BIA shall identify the organization's activities and the resources they depend on, assess the impact over time of their disruption, and establish prioritized recovery objectives — maximum tolerable period of disruption, recovery time objectives and recovery point objectives — that drive the selection of continuity strategies. Review the BIA methodology, the latest completed analysis and evidence that its outputs feed continuity planning.",
  category: 'continuity',
  scfIds: ['SCF-BCM-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Business impact analysis is published' },
    { type: 'document-approved', description: 'BIA has been approved' },
    { type: 'document-within-sla', description: 'BIA review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
